import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { TableListComponent } from '../../shared/components/table-list/table-list.component'
import { AuthService } from '../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../core/models/contact-type.model'
import { FormSearchComponent } from '../../shared/components/form-search/form-search.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import {MatCard} from '@angular/material/card';
import {ClassificationCreateComponent} from '../../features/classification/classification-create/classification-create-component';
import {SnackbarCustomService} from '../../shared/components/snackbar/snackbar-custom.service';
import {MessageService} from '../../core/services/message/message/message.service';
import {MessageCreateComponent} from '../../features/message/message-create/message-create.component';
import {MessageEditComponent} from '../../features/message/message-edit/message-edit.component';
import {MatButton} from '@angular/material/button';
import {HealthAgentCreateComponent} from '../../features/health-agent/doctor-create/health-agent-create.component';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {MessageTypeService} from '../../core/services/message-type/document-type/message-type.service';

@Component({
  selector: 'message',
  imports: [
    MatProgressBar,
    TableListComponent,
    FormSearchComponent,
    MatPaginatorModule,
    MatButton,
    FormsModule,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
  ],
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
  providers: [MessageService, AuthService],
  standalone: true,
})
export class MessageComponent implements OnInit {
  constructor(
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private messageTypeService: MessageTypeService,
    private authService: AuthService,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,
  ) {}
  page: number = 1
  rows: number = 10
  numberRows: number = 0
  form: FormGroup = new FormGroup({})
  itemsList: any[] = []
  listUseTypes: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    {
      keyColumn: 'id',
      key: 'id',
      description: 'Código',
    },
    {
      keyColumn: 'nome',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'texto',
      key: 'texto',
      description: 'Texto',
    },
    {
      keyColumn: 'tipo-uso',
      key: 'tipo_uso_nome',
      description: 'Tipo de Uso',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  screen: string = 'mensagemtemplate'

  ngOnInit() {
    this.checkColumnAction()
    this.createForm()
    this.getUseTypes()
    this.getListItems()
  }
  createForm(){
    this.form = this.formBuilder.group({
      tipo_uso: new FormControl(null),
    })
  }
  getUseTypes(): void {
    this.messageTypeService.listMessageType().subscribe({
      next: result => {
        this.listUseTypes = result.data
      },
      error: error => {
        console.log(error)
      }
      }
    )
  }
  tipo_uso: number | string | null = null
  onChange(){
    this.tipo_uso = this.form.controls['tipo_uso']?.value
    this.page = 1
    this.uploadList()
  }
  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.nome = search
      this.searchListItems()
    } else {
      this.tipo_uso = null
      this.form.controls['tipo_uso']?.setValue(null)
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.paging.total
  }

  getListItems() {
    this.loading = true
    this.messageService.listPagedMessage(this.page, this.rows, this.tipo_uso).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.messageService
      .searchPagedLocation(this.page, this.rows, this.searchForm, this.tipo_uso)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  newEmployee() {
    const dialogRef = this.dialog.open(ClassificationCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '950px',
      // height: '100vh',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }
  newDriver() {
    const dialogRef = this.dialog.open(MessageCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '50vw',
      width: '50vw',
      maxHeight: '50vh',
      height: '50vh',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }
  editItem(item: any) {
    const dialogRef = this.dialog.open(MessageEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '50vw',
      width: '50vw',
      maxHeight: '50vh',
      height: '50vh',
      data: {item},
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      this.uploadList()
    })
  }

  deleteItem(item: any) {
    this.messageService.deleteMessage(item.id).subscribe({
      next: (response: any) => {
        console.log(response.data)
        this.snackbar.success(response.message)
      },
      error: (erro: any) => {
        this.snackbar.error("Erro ao excluir mensagem, verifique se essa mensagem nao está associada a um lembrete ou a uma regra de alerta")
      },
      complete: () => {
        this.getListItems()
      }
    })
  }
}
